import { connect, } from "react-redux";
export default connect;
